// extracted by mini-css-extract-plugin
module.exports = {"heading":"form_heading__3Xe49","buscador":"form_buscador__3K0yL","btn_block":"form_btn_block__2ILm4"};